// Wert service availability for Fiat Onramp.
// Source: https://docs.wert.io/docs/service-availability
// Last synced: 2026-05-24 — re-sync periodically (Wert updates this page)
// NFT Checkout column is intentionally omitted (we don't use it).

export type RegionStatus = "supported" | "unsupported";

export type Region = {
  name: string;
  status: RegionStatus;
};

export const WERT_COUNTRIES: Region[] = [
  { name: "Afghanistan", status: "unsupported" },
  { name: "Åland Islands", status: "supported" },
  { name: "Albania", status: "unsupported" },
  { name: "Algeria", status: "unsupported" },
  { name: "American Samoa", status: "supported" },
  { name: "Andorra", status: "supported" },
  { name: "Angola", status: "supported" },
  { name: "Anguilla", status: "supported" },
  { name: "Antigua and Barbuda", status: "supported" },
  { name: "Argentina", status: "supported" },
  { name: "Armenia", status: "unsupported" },
  { name: "Aruba", status: "supported" },
  { name: "Australia", status: "supported" },
  { name: "Austria", status: "supported" },
  { name: "Azerbaijan", status: "unsupported" },
  { name: "Bahamas", status: "unsupported" },
  { name: "Bahrain", status: "supported" },
  { name: "Bangladesh", status: "supported" },
  { name: "Barbados", status: "unsupported" },
  { name: "Belarus", status: "unsupported" },
  { name: "Belgium", status: "supported" },
  { name: "Belize", status: "supported" },
  { name: "Benin", status: "supported" },
  { name: "Bermuda", status: "supported" },
  { name: "Bhutan", status: "supported" },
  { name: "Bolivia", status: "unsupported" },
  { name: "Bonaire, Sint Eustatius and Saba", status: "supported" },
  { name: "Bosnia and Herzegovina", status: "unsupported" },
  { name: "Botswana", status: "unsupported" },
  { name: "Bouvet Island", status: "unsupported" },
  { name: "Brazil", status: "supported" },
  { name: "British Indian Ocean Territory", status: "supported" },
  { name: "British Virgin Islands", status: "supported" },
  { name: "Brunei Darussalam", status: "supported" },
  { name: "Bulgaria", status: "supported" },
  { name: "Burkina Faso", status: "unsupported" },
  { name: "Burundi", status: "supported" },
  { name: "Cambodia", status: "unsupported" },
  { name: "Cameroon", status: "supported" },
  { name: "Canada", status: "supported" },
  { name: "Cape Verde (Cabo Verde)", status: "supported" },
  { name: "Cayman Islands", status: "unsupported" },
  { name: "Central African Republic", status: "unsupported" },
  { name: "Chad", status: "supported" },
  { name: "Chile", status: "supported" },
  { name: "China", status: "unsupported" },
  { name: "Christmas Island", status: "supported" },
  { name: "Cocos (Keeling) Islands", status: "supported" },
  { name: "Colombia", status: "supported" },
  { name: "Comoros", status: "supported" },
  { name: "Cook Islands", status: "supported" },
  { name: "Costa Rica", status: "supported" },
  { name: "Cote D'Ivoire", status: "supported" },
  { name: "Croatia", status: "supported" },
  { name: "Cuba", status: "unsupported" },
  { name: "Curaçao", status: "supported" },
  { name: "Cyprus", status: "supported" },
  { name: "Czech Republic", status: "supported" },
  { name: "Democratic Republic of the Congo", status: "unsupported" },
  { name: "Denmark", status: "supported" },
  { name: "Djibouti", status: "supported" },
  { name: "Dominica", status: "supported" },
  { name: "Dominican Republic", status: "supported" },
  { name: "Ecuador", status: "unsupported" },
  { name: "Egypt", status: "unsupported" },
  { name: "El Salvador", status: "supported" },
  { name: "Equatorial Guinea", status: "supported" },
  { name: "Eritrea", status: "supported" },
  { name: "Estonia", status: "supported" },
  { name: "Eswatini (Swaziland)", status: "supported" },
  { name: "Ethiopia", status: "unsupported" },
  { name: "Falkland Islands (Malvinas)", status: "supported" },
  { name: "Faroe Islands", status: "supported" },
  { name: "Fiji", status: "supported" },
  { name: "Finland", status: "supported" },
  { name: "France", status: "supported" },
  { name: "French Guiana", status: "supported" },
  { name: "French Polynesia", status: "supported" },
  { name: "French Southern Territories", status: "unsupported" },
  { name: "Gabon", status: "supported" },
  { name: "Gambia", status: "supported" },
  { name: "Georgia", status: "supported" },
  { name: "Germany", status: "supported" },
  { name: "Ghana", status: "unsupported" },
  { name: "Gibraltar", status: "unsupported" },
  { name: "Greece", status: "supported" },
  { name: "Greenland", status: "supported" },
  { name: "Grenada", status: "supported" },
  { name: "Guadeloupe", status: "supported" },
  { name: "Guam", status: "supported" },
  { name: "Guatemala", status: "supported" },
  { name: "Guernsey", status: "supported" },
  { name: "Guinea", status: "supported" },
  { name: "Guinea-Bissau", status: "unsupported" },
  { name: "Guyana", status: "unsupported" },
  { name: "Haiti", status: "unsupported" },
  { name: "Heard Island and McDonald Islands", status: "unsupported" },
  { name: "Honduras", status: "supported" },
  { name: "Hong Kong", status: "supported" },
  { name: "Hungary", status: "supported" },
  { name: "Iceland", status: "unsupported" },
  { name: "India", status: "supported" },
  { name: "Indonesia", status: "supported" },
  { name: "Iran", status: "unsupported" },
  { name: "Iraq", status: "unsupported" },
  { name: "Ireland", status: "supported" },
  { name: "Isle of Man", status: "supported" },
  { name: "Israel", status: "supported" },
  { name: "Italy", status: "supported" },
  { name: "Jamaica", status: "unsupported" },
  { name: "Japan", status: "supported" },
  { name: "Jersey", status: "supported" },
  { name: "Jordan", status: "supported" },
  { name: "Kazakhstan", status: "supported" },
  { name: "Kenya", status: "supported" },
  { name: "Kiribati", status: "supported" },
  { name: "Kosovo", status: "supported" },
  { name: "Kuwait", status: "supported" },
  { name: "Kyrgyzstan", status: "supported" },
  { name: "Laos", status: "unsupported" },
  { name: "Latvia", status: "supported" },
  { name: "Lebanon", status: "unsupported" },
  { name: "Lesotho", status: "supported" },
  { name: "Liberia", status: "supported" },
  { name: "Libya", status: "unsupported" },
  { name: "Liechtenstein", status: "supported" },
  { name: "Lithuania", status: "supported" },
  { name: "Luxembourg", status: "supported" },
  { name: "Macau", status: "supported" },
  { name: "Macedonia", status: "supported" },
  { name: "Madagascar", status: "supported" },
  { name: "Malawi", status: "supported" },
  { name: "Malaysia", status: "supported" },
  { name: "Maldives", status: "supported" },
  { name: "Mali", status: "unsupported" },
  { name: "Malta", status: "supported" },
  { name: "Marshall Islands", status: "supported" },
  { name: "Martinique", status: "supported" },
  { name: "Mauritania", status: "supported" },
  { name: "Mauritius", status: "unsupported" },
  { name: "Mayotte", status: "supported" },
  { name: "Mexico", status: "supported" },
  { name: "Micronesia", status: "supported" },
  { name: "Moldova", status: "supported" },
  { name: "Monaco", status: "supported" },
  { name: "Mongolia", status: "unsupported" },
  { name: "Montenegro", status: "supported" },
  { name: "Montserrat", status: "supported" },
  { name: "Morocco", status: "supported" },
  { name: "Mozambique", status: "supported" },
  { name: "Myanmar (Burma)", status: "unsupported" },
  { name: "Namibia", status: "supported" },
  { name: "Nauru", status: "supported" },
  { name: "Nepal", status: "unsupported" },
  { name: "Netherlands", status: "supported" },
  { name: "New Caledonia", status: "supported" },
  { name: "New Zealand", status: "supported" },
  { name: "Nicaragua", status: "unsupported" },
  { name: "Niger", status: "supported" },
  { name: "Nigeria", status: "unsupported" },
  { name: "Niue", status: "supported" },
  { name: "Norfolk Island", status: "supported" },
  { name: "Northern Mariana Islands", status: "supported" },
  { name: "North Korea", status: "unsupported" },
  { name: "Norway", status: "supported" },
  { name: "Oman", status: "supported" },
  { name: "Pakistan", status: "unsupported" },
  { name: "Palau", status: "supported" },
  { name: "Palestine", status: "supported" },
  { name: "Panama", status: "unsupported" },
  { name: "Papua New Guinea", status: "supported" },
  { name: "Paraguay", status: "supported" },
  { name: "Peru", status: "supported" },
  { name: "Philippines", status: "supported" },
  { name: "Pitcairn", status: "supported" },
  { name: "Poland", status: "supported" },
  { name: "Portugal", status: "supported" },
  { name: "Puerto Rico", status: "supported" },
  { name: "Qatar", status: "unsupported" },
  { name: "Republic of the Congo", status: "supported" },
  { name: "Réunion", status: "supported" },
  { name: "Romania", status: "supported" },
  { name: "Russia", status: "unsupported" },
  { name: "Rwanda", status: "supported" },
  { name: "Saint Barthélemy", status: "supported" },
  { name: "Saint Helena, Ascension and Tristan da Cunha", status: "supported" },
  { name: "Saint Kitts and Nevis", status: "supported" },
  { name: "Saint Lucia", status: "supported" },
  { name: "Saint Martin (French part)", status: "supported" },
  { name: "Saint Pierre and Miquelon", status: "supported" },
  { name: "Saint Vincent and the Grenadines", status: "supported" },
  { name: "Samoa", status: "supported" },
  { name: "San Marino", status: "supported" },
  { name: "São Tomé and Príncipe", status: "supported" },
  { name: "Saudi Arabia", status: "supported" },
  { name: "Senegal", status: "unsupported" },
  { name: "Serbia", status: "supported" },
  { name: "Seychelles", status: "supported" },
  { name: "Sierra Leone", status: "supported" },
  { name: "Singapore", status: "supported" },
  { name: "Sint Maarten", status: "supported" },
  { name: "Slovakia", status: "supported" },
  { name: "Slovenia", status: "supported" },
  { name: "Solomon Islands", status: "supported" },
  { name: "Somalia", status: "unsupported" },
  { name: "South Africa", status: "supported" },
  { name: "South Georgia and the South Sandwich Islands", status: "unsupported" },
  { name: "South Korea", status: "supported" },
  { name: "South Sudan", status: "unsupported" },
  { name: "Spain", status: "supported" },
  { name: "Sri Lanka", status: "supported" },
  { name: "Sudan", status: "unsupported" },
  { name: "Suriname", status: "supported" },
  { name: "Svalbard and Jan Mayen", status: "supported" },
  { name: "Sweden", status: "supported" },
  { name: "Switzerland", status: "supported" },
  { name: "Syria", status: "unsupported" },
  { name: "Taiwan", status: "supported" },
  { name: "Tajikistan", status: "supported" },
  { name: "Tanzania", status: "supported" },
  { name: "Thailand", status: "supported" },
  { name: "Timor-Leste", status: "supported" },
  { name: "Togo", status: "supported" },
  { name: "Tokelau", status: "supported" },
  { name: "Tonga", status: "supported" },
  { name: "Trinidad and Tobago", status: "unsupported" },
  { name: "Tunisia", status: "unsupported" },
  { name: "Turkey", status: "unsupported" },
  { name: "Turkmenistan", status: "supported" },
  { name: "Turks and Caicos Islands", status: "supported" },
  { name: "Tuvalu", status: "supported" },
  { name: "Uganda", status: "unsupported" },
  { name: "Ukraine", status: "unsupported" },
  { name: "United Arab Emirates", status: "supported" },
  { name: "United Kingdom", status: "supported" },
  { name: "United States", status: "supported" },
  { name: "United States Virgin Islands", status: "supported" },
  { name: "Uruguay", status: "supported" },
  { name: "U.S. Minor Outlying Islands", status: "unsupported" },
  { name: "Uzbekistan", status: "supported" },
  { name: "Vanuatu", status: "unsupported" },
  { name: "Vatican City (Holy See)", status: "supported" },
  { name: "Venezuela", status: "unsupported" },
  { name: "Vietnam", status: "supported" },
  { name: "Wallis and Futuna", status: "supported" },
  { name: "Western Sahara", status: "unsupported" },
  { name: "Yemen", status: "unsupported" },
  { name: "Zambia", status: "supported" },
  { name: "Zimbabwe", status: "unsupported" },
];

export const WERT_US_STATES: Region[] = [
  { name: "Alabama", status: "unsupported" },
  { name: "Alaska", status: "unsupported" },
  { name: "Arizona", status: "supported" },
  { name: "Arkansas", status: "supported" },
  { name: "California", status: "supported" },
  { name: "Colorado", status: "supported" },
  { name: "Connecticut", status: "supported" },
  { name: "Delaware", status: "supported" },
  { name: "Florida", status: "supported" },
  { name: "Georgia", status: "supported" },
  { name: "Hawaii", status: "unsupported" },
  { name: "Idaho", status: "supported" },
  { name: "Illinois", status: "supported" },
  { name: "Indiana", status: "supported" },
  { name: "Iowa", status: "supported" },
  { name: "Kansas", status: "supported" },
  { name: "Kentucky", status: "supported" },
  { name: "Louisiana", status: "supported" },
  { name: "Maine", status: "supported" },
  { name: "Maryland", status: "supported" },
  { name: "Massachusetts", status: "supported" },
  { name: "Michigan", status: "supported" },
  { name: "Minnesota", status: "supported" },
  { name: "Mississippi", status: "supported" },
  { name: "Missouri", status: "supported" },
  { name: "Montana", status: "supported" },
  { name: "Nebraska", status: "supported" },
  { name: "Nevada", status: "unsupported" },
  { name: "New Hampshire", status: "supported" },
  { name: "New Jersey", status: "supported" },
  { name: "New Mexico", status: "unsupported" },
  { name: "New York", status: "unsupported" },
  { name: "North Carolina", status: "supported" },
  { name: "North Dakota", status: "supported" },
  { name: "Ohio", status: "supported" },
  { name: "Oklahoma", status: "supported" },
  { name: "Oregon", status: "unsupported" },
  { name: "Pennsylvania", status: "supported" },
  { name: "Puerto Rico", status: "unsupported" },
  { name: "Rhode Island", status: "supported" },
  { name: "South Carolina", status: "supported" },
  { name: "South Dakota", status: "supported" },
  { name: "Tennessee", status: "supported" },
  { name: "Texas", status: "supported" },
  { name: "U.S. Virgin Islands", status: "unsupported" },
  { name: "Utah", status: "supported" },
  { name: "Vermont", status: "unsupported" },
  { name: "Virginia", status: "supported" },
  { name: "Washington", status: "unsupported" },
  { name: "Washington DC", status: "unsupported" },
  { name: "West Virginia", status: "unsupported" },
  { name: "Wisconsin", status: "supported" },
  { name: "Wyoming", status: "supported" },
];
